import { render, staticRenderFns } from "./CbsDataTable.vue?vue&type=template&id=7f4a453a&scoped=true"
import script from "./CbsDataTable.vue?vue&type=script&lang=js"
export * from "./CbsDataTable.vue?vue&type=script&lang=js"
import style0 from "./CbsDataTable.vue?vue&type=style&index=0&id=7f4a453a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4a453a",
  null
  
)

export default component.exports